import {Injectable} from "@angular/core";
import {UserService} from "../../api/services/user.service";
import {map, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {NdmsUserManagementService} from "../../../../shared/core/app/api/services/ndms-user-management.service";



@Injectable()
export class RmsUserManagementService {
  public static currentData: any;
  public static currentNdmsData: any;

  constructor(private userService:UserService,
              private ndmsUserManagementService: NdmsUserManagementService) {

  }

  getCurrentCachedUser() {
    if (RmsUserManagementService.currentData && RmsUserManagementService.currentData.key !== null) {
      return new Observable<any>((observer)=> {
        observer.next(RmsUserManagementService.currentData);
      });
    }

    return this.userService.GetCurrent().pipe(map((res)=>{
      RmsUserManagementService.currentData = res.model;
      return res.model
    }));
  }
  get() {
    return this.userService.Get().pipe(map((res)=>{
      return res;
    }));
  }
  createUser(user){
    return this.userService.CreateUser(user).pipe(tap());
  }
  approveUser(user){
    return this.ndmsUserManagementService.UpdateUserAccess({accountStatus:{key:"401.2"},appItemName:"rms",userKey:user.key}).pipe(tap());
  }
  denyUser(user){
    return this.ndmsUserManagementService.UpdateUserAccess({accountStatus:{key:"401.3"},appItemName:"rms",userKey:user.key}).pipe(tap());
  }
  getUserRoles() {
    return this.userService.GetAllRoles().pipe(map((res)=>{
      return res;
    }));
  }
  updateUserInfo(user){
    return this.userService.Save({userId:user.id, userModel:user}).pipe(map((res)=>{
      return res.model;
    }));
  }
  getAllUsers(params){
    return this.userService.Query(params).pipe(map((res)=>{
      return res;
    }));
  }
  getAllPendingUsers(params){
    return this.ndmsUserManagementService.PendingUsersByAppName(Object.assign({},{appName:"rms"},params)).pipe(tap());
  }
  updateLocation(locationInfo){
    return this.userService.SaveCurrent(locationInfo).pipe(map((res)=>{
      RmsUserManagementService.currentData = undefined;
    }));
  }
}
